var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNarrativeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1125 314.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.3;stroke:#fff;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:5px;}.cls-3{fill:#d1e5e1;}.cls-2{opacity:.13;stroke:#000;}.cls-4{fill:#b4ccc7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1125 283.46 242.1 283.46 78.31 283.46 0 283.46 0 0 85.48 0 234.38 .82 1125 .82 1125 283.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1125 314.46 242.1 314.46 78.31 314.46 0 314.46 0 31.83 1125 31.83 1125 314.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1125 298.46 242.1 298.46 78.31 298.46 0 298.46 0 15 85.48 15 234.38 15.83 1125 15.83 1125 298.46"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    y1: 127.7,
    x2: 1125,
    y2: 127.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 132.78,
    x2: 1125,
    y2: 132.78
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrativeBg);
export default __webpack_public_path__ + "static/media/narrative-bg.a90ccc9969714522771b387ffb54ecea.svg";
export { ForwardRef as ReactComponent };